import media from 'src/styles/Media.styled';
import styled from 'styled-components';
import {
    DARK_NAVY_FONT_COLOR,
    BLACK_FONT_COLOR,
    FONT_FAMILY_DEMI,
    FONT_FAMILY_REGULAR,
    SEMANTIC_TEXT_SMALL_PX,

} from 'src/styles/fonts/MCFontConstants';

export const BannerContainer = styled.div`
    display: ${(props) => (props.bannerDisplay ? props.bannerDisplay : 'flex')};
    width: 100%;
    justify-content: space-between;
    background-color: ${({ backgroundColor, proxyBackgroundColor, adminImpersonateBGColor }) =>
        backgroundColor
            ? '#98fff7'
            : proxyBackgroundColor
            ? '#00DCB9'
            : adminImpersonateBGColor ? '#12C8F7' : '#12C8F7'};
    padding: ${({ padding }) => (padding ? '9px 15px' : '10px')};
    align-items: center;
    min-height: 3.75rem;
`;

export const TextContainer = styled.div`
    width: ${({ webWidth }) => (webWidth ? webWidth : '')};
    display: flex;
    align-items: ${({ alignItems }) => (alignItems ? 'flex-start' : 'center')};
    margin-left: 12px;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? 'column' : 'row'};
    // overflow: scroll;
    text-overflow: ellipses;
    ${media.mediumDevice`
        width:${({ width }) => (width ? width : '90%')};
        margin-left:0px;
    `}
    ${media.mobileDevice`
        width: ${({ width }) => (width ? width : '69%')};
        margin-left:0px;
    `}
    & p {
        margin-block-start: 0em;
        margin-block-end: 0em;
    }
`;

export const Text = styled.div`
    margin: 0;
    width: max-content;
    font-size: ${`${SEMANTIC_TEXT_SMALL_PX} !important`};
    font-family: ${FONT_FAMILY_DEMI};
    line-height: 20px;
    color: ${DARK_NAVY_FONT_COLOR};
    ${media.mobileDevice`
        width:95%;
        display: -webkit-box;
        -webkit-box-orient: vertical;
       // -webkit-line-clamp:  ${({ lineClamp }) => (lineClamp ? '' : '2')};
    `}
`;

export const Title = styled.div`
    color: ${BLACK_FONT_COLOR};
    font-size: ${SEMANTIC_TEXT_SMALL_PX};
    font-family: ${FONT_FAMILY_DEMI};
`;

export const SubText = styled.div`
    color: ${BLACK_FONT_COLOR};
    font-size: ${(props) => (props.fontSize ? props.fontSize : SEMANTIC_TEXT_SMALL_PX)};
    font-family: ${FONT_FAMILY_REGULAR};
    ${media.mobileDevice`
        width: 94%;
        white-space: nowrap;
    `}
`;
